module.exports = __webpack_public_path__ + "img/menu-icon.f157dec0.svg";